export const TRANSLATIONS_ES_DOCUMENTS_AND_DRIVE = {
  "upload.title": "Subir Documentos",
  "upload.drag": "Arrastra y suelta archivos aquí",
  "upload.select": "Seleccionar Archivos",
  "upload.formats": "Formatos soportados: PDF, DOCX, XLSX, TXT, JSON, CSV, MD",
  "upload.processing": "Procesando...",
  "upload.success": "Documento procesado exitosamente",
  "upload.error": "Error al procesar el documento",
  "upload.process_immediately": "Procesar inmediatamente",
  "upload.folder_name": "Nombre de la carpeta",
  "upload.folder_placeholder": "Nombre de la carpeta",
  "upload.tags": "Etiquetas",
  "upload.add_tag": "Etiquetas (separadas por comas)",
  "upload.viewer_role": "Rol para visualización",
  "upload.role_viewer": "Visualizador (predeterminado)",
  "upload.loading_roles": "Cargando roles...",
  "upload.viewer_role_help": "Selecciona el rol mínimo requerido para ver este documento",
  "upload.files_to_upload": "Archivos a subir",
  "upload.upload_all": "Subir todo",
  "upload.role_id": "Rol de acceso",
  "upload.role_id_help": "Opcional: restringe qué rol puede ver este documento.",
  "upload.role_id_required": "Selecciona un rol.",
  "upload.select_role": "Selecciona un rol",
  "upload.queued.title": "Archivo encolado",
  "upload.queued.message": "El archivo ha sido encolado para su procesamiento.",
  "upload.queued.taskId": "ID de tarea",
  "upload.queued.checkTasks":
    "Puedes revisar el estado en la sección de tareas.",
  "upload.duplicated.title": "Archivo duplicado",
  "upload.duplicated.message":
    "Ya existe un documento llamado '{{name}}'. ¿Deseas reemplazarlo?",
  "upload.duplicated.replace": "Reemplazar",
  "upload.success.title": "¡Subida exitosa!",
  "upload.success.message":
    "El documento '{{name}}' se subió correctamente a la carpeta '{{folder}}'.",
  "documents.loading": "Cargando documentos...",
  "documents.name": "Nombre",
  "documents.source": "Fuente",
  "documents.vectors": "Vectores Usados",
  "documents.date": "Fecha",
  "documents.delete_document_tooltip": "Eliminar documento",
  "documents.delete_confirm.title": "Eliminar documento",
  "documents.delete_confirm.body": "Esta acción no se puede deshacer.",
  "documents.delete_confirm.confirm": "Eliminar",
  "documents.delete_confirm.error": "No se pudo eliminar el documento.",
  "documents.download_document_tooltip": "Descargar documento",
  "documents.context.ask_only_this": "Hacer preguntas solo sobre este documento",
  "documents.context.confirm_only_this": "¿Limitar chat a este documento?",
  "documents.no_documents":
    'No hay documentos indexados. Sube algunos documentos en la sección "Subir Documentos".',
  "documents.refresh": "Actualizar",
  "documents.indexed_documents":
    "Lista de documentos actualmente indexados en el sistema.",
  "documents.indexed_documents_title": "Documentos indexados",
  "documents.domains": "Dominios",
  "documents.other_domains": "Otros dominios",
  "documents.documents_word": "documentos",
  "documents.search_domain": "Buscar dominio...",
  "documents.no_domain_results": "Sin resultados",
  "documents.subdomains": "Subdominios",
  "documents.clear_filter": "Quitar filtro",
  "documents.back": "Volver",
  "documents.domain_distribution": "Distribución por dominio",
  "documents.subdomain_distribution":
    "Distribución por subdominio de {{domain}}",
  "documents.select_domain_hint":
    "Selecciona un dominio para ver sus subdominios y documentos.",
  "documents.select_subdomain_hint":
    "Selecciona un subdominio para ver sus documentos.",
  "documents.redirecting_to_details":
    "Redirigiendo a detalles del documento...",
  "documents.details_for_type": "Documentos para el tipo: {{type}}",
  "documents.details_for_domain": "Documentos para el dominio: {{domain}}",
  "documents.details_all": "Todos los documentos",
  "documents.group_type": "Tipo",
  "documents.group_domain": "Dominio",
  "documents.no_documents_in_group": "No hay documentos en este grupo.",
  "documents.no_documents_found": "No se encontraron documentos.",
  "documents.tab_overview": "Resumen",
  "documents.tab_details": "Detalles",
  "documents.tab_viewer": "Visor",
  "documents.sidebar_types": "Tipos",
  "documents.types_distribution": "Distribución por tipo",
  "documents.type_.pdf": "PDF",
  "documents.type_.docx": "DOCX",
  "documents.type_.txt": "TXT",
  "documents.type_.csv": "CSV",
  "documents.type_.xlsx": "XLSX",
  "documents.type_.pptx": "PPTX",
  "documents.type_.email": "Correo",
  "documents.type_.other": "Otro",
  "documents.type_.md": "MD",
  "documents.group_today": "Hoy",
  "documents.group_last3days": "Últimos 3 días",
  "documents.group_lastweek": "Última semana",
  "documents.group_lastmonth": "Último mes",
  "documents.group_older": "Más antiguos",
  "documents.tab_network": "Semántica",
  "drive.viewer_aria_label": "Visor Mi unidad (solo lectura)",
  "drive.search_placeholder": "Buscar en Mi unidad",
  "drive.my_drive": "Mi unidad",
  "drive.filter.type.aria": "Filtrar por tipo",
  "drive.filter.type.label_all": "Tipo: Todos",
  "drive.type.folder": "Carpeta",
  "drive.type.doc": "Documento",
  "drive.type.sheet": "Hoja de cálculo",
  "drive.type.slide": "Presentación",
  "drive.type.pdf": "PDF",
  "drive.type.image": "Imagen",
  "drive.type.video": "Vídeo",
  "drive.type.zip": "ZIP",
  "drive.type.other": "Otros",
  "drive.filter.owner.aria": "Filtrar por propietario",
  "drive.filter.owner.label_all": "Propietario: Cualquiera",
  "drive.owner.you": "Tú",
  "drive.owner.external": "Externo",
  "drive.owner.any": "Cualquiera",
  "drive.details": "Detalles",
  "drive.tree_aria_label": "Árbol Mi unidad",
  "drive.breadcrumbs_aria_label": "Ruta actual",
  "drive.view.list": "Lista",
  "drive.view.grid": "Cuadrícula",
  "drive.view.list_aria": "Vista de lista",
  "drive.view.grid_aria": "Vista de cuadrícula",
  "drive.sort.by": "Ordenar por",
  "drive.sort.dir": "Dirección de orden",
  "drive.sort.key.name": "Nombre",
  "drive.sort.key.type": "Tipo de archivo",
  "drive.sort.key.owner": "Propietario",
  "drive.sort.key.modified": "Última modificación",
  "drive.sort.key.size": "Tamaño",
  "drive.dir.asc": "Asc",
  "drive.dir.desc": "Desc",
  "drive.results_showing": "Mostrando",
  "drive.table.aria_label": "Lista de elementos",
  "drive.table.name": "Nombre",
  "drive.table.file_type": "Tipo de archivo",
  "drive.table.owner": "Propietario",
  "drive.table.last_modified": "Última modificación",
  "drive.table.size": "Tamaño",
  "drive.shared": "Compartido",
  "drive.preview": "Vista previa",
  "drive.details.name": "Nombre",
  "drive.details.type": "Tipo",
  "drive.details.location": "Ubicación",
  "drive.details.owner": "Propietario",
  "drive.details.size": "Tamaño",
  "drive.details.created": "Creación",
  "drive.details.last_modified": "Última modificación",
  "drive.details.shared": "Compartido",
  "drive.yes": "Sí",
  "drive.no": "No",
  "drive.details.permissions": "Permisos",
  "drive.permissions.read_only": "Solo lectura",
  "drive.no_selection_hint": "Selecciona un elemento para ver sus detalles.",
  "drive.filters_aria": "Filtros",
  "drive.hide_tree": "Ocultar árbol",
  "drive.show_tree": "Mostrar árbol",
  "drive.refreshing": "Actualizando...",
  "drive.loading_files": "Cargando archivos...",
  "drive.preview.loading": "Cargando vista previa...",
  "drive.preview.not_available": "Vista previa no disponible",
  "drive.by_date": "Por fecha",
  "drive.status.items": "elementos",
  "drive.status.items_one": "elemento",
  "drive.status.of": "de",
  "drive.status.selected": "seleccionados",
  "drive.status.selected_one": "seleccionado",
  "drive.type.email": "Correo",
  "drive.context.move_to": "Mover a",
  "drive.context.no_move_targets": "No hay carpetas disponibles",
  "drive.move_dialog.title": "Mover documentos",
  "drive.move_dialog.search": "Buscar carpetas",
  "drive.move_dialog.items_suffix": "elementos",
  "drive.move_dialog.moving": "Moviendo...",
  "drive.move_dialog.error": "No se pudo mover el archivo. Verifica permisos o intenta de nuevo.",
  "drive.move_dialog.invalid_target": "Selecciona una carpeta destino valida.",
  "drive.bytes": "bytes",
  "documents.error_loading": "Error al cargar documentos",
  "documents.error_deleting": "Error al eliminar documento",
  "documents.selected_type": "Tipo seleccionado",
  "documents.selected_document": "Documento seleccionado",
  "documents.group_lastWeek": "Última semana",
  "documents.group_lastMonth": "Último mes",
  "upload.clear_completed": "Limpiar completados",
  "drive.contextMenu.generateSummary": "Generar Resumen",
  "drive.generateSummary.modalTitle": "Documentos seleccionados",
  "drive.generateSummary.modalHint": "Se generará un resumen ejecutivo de estos documentos.",
  "drive.generateSummary.goToGenerate": "Ir a Generar",
  "drive.generateSummary.noDocuments": "Selecciona al menos un documento indexado.",
  "documents.versions.action": "Historial de versiones",
  "documents.versions.title": "Historial de versiones",
  "documents.versions.empty": "Este documento aún no tiene versiones.",
  "documents.versions.error": "No se pudo cargar el historial de versiones.",
  "documents.versions.active": "Vigente",
  "documents.versions.close": "Cerrar",
};
